import { SPRITE_SHEET, SPRITE_URL, spriteRectForIcon } from '../mapSpriteIcons';

type Props = {
  className?: string;
  icon: string;
  viewBox?: string;
};

const Svg = ({ className, icon, viewBox }: Props) => {
  // Marker-type icons (water, POI) render from the shared map sprite so the UI
  // matches the map exactly. The cropped viewBox windows onto the icon's rect
  // within the full sheet; the element is sized by CSS like any other Svg.
  const spriteRect = spriteRectForIcon(icon);
  if (spriteRect) {
    const { x, y, width, height } = spriteRect;
    return (
      <svg className={className} viewBox={`${x} ${y} ${width} ${height}`}>
        <image href={SPRITE_URL} width={SPRITE_SHEET.width} height={SPRITE_SHEET.height} />
      </svg>
    );
  }

  return (
    <svg className={className} viewBox={viewBox}>
      <use href={`#${icon}`} />
    </svg>
  );
};

export default Svg;
